function download() //saves results locally
{
  //mark trial start for analytics
  sendEndAnalytics();

  Bugsnag && Bugsnag.leaveBreadcrumb('[download] Reached end of experiment. Start.', {save_on_computer:save_on_computer, save_on_server:save_on_server}, 'state');

  var csvContentLocal = "data:text/csv;charset=utf-8," + csvContentServer;
  var participant_id = document.forms["P_details"]["name"].value;

  if (window.mindId) {
    participant_id = window.mindId;
  }


  var d = new Date();
  var timeSaved = d.getUTCFullYear().toString().slice(-2)+("0"+(d.getUTCMonth()+1)).slice(-2)+("0"+d.getUTCDate()).slice(-2)+"_"+("0"+d.getUTCHours()).slice(-2)+("0"+d.getUTCMinutes()).slice(-2)+("0"+d.getUTCSeconds()).slice(-2);
  fileNameServer = experimentName + "_" + timeSaved;
  fileNameLocal = experimentName + "_" + timeSaved;

  if (participant_id) {
    fileNameServer = fileNameServer + "_" + participant_id;
    fileNameLocal = fileNameLocal + "_" + participant_id;
  }

  fileNameServer += ".csv";
  fileNameLocal += ".csv";


document.forms["hiddenForm"]["fileNameSubmit"].value = fileNameServer;
document.forms["hiddenForm"]["dataSubmit"].value = csvContentServer;

// document.forms["hiddenForm"].submit();
// var dataString = 'fileNameSubmit='+ fileNameServer + '&dataSubmit=' + csvContentServer + '&randomCode=' + randomCode;
console.log('csv content', csvContentServer);
var dataString =
{
 fileNameSubmit: fileNameServer,
 dataSubmit: csvContentServer,
 randomCode: randomCode,
 startTimestamp: window.startTimestamp,
}

Bugsnag && Bugsnag.leaveBreadcrumb('[download] Reached end of experiment.', {fileNameServer: fileNameServer}, 'state');
Bugsnag && Bugsnag.leaveBreadcrumb('[download] Reached end of experiment.', window.dbids.includes(window.projectOwnerId) && dataString, 'state');

if (recaptcha == 1 && mindId == '') {
  dataString.antibotToken = window.antibot_token;
}

var isIE = false;
if(navigator.userAgent.indexOf('MSIE')!==-1
|| navigator.userAgent.indexOf('Edge')!==-1
|| navigator.appVersion.indexOf('Trident/') > 0)
{
	isIE = true;
}

if (save_on_server == "on" || isIE)
{
  saveRemote();
}
console.log(save_on_computer);
//save locally
if (save_on_computer == "on") {
  $.post('canSave', function (response){
    if (response == '1') {
      saveLocally();
    } else {
      if (save_on_server != "on") {
        saveRemote();
      }
    }
  })
  .fail(function() {
    saveLocally();
  });
}

  function saveRemote() {
    Bugsnag && Bugsnag.leaveBreadcrumb('[download][saveRemote] Start');
      const progressHTML =
        '<div id="uploadResultsStatus" style="width: 70%; margin-left:15%">' +
          '<h3 id="uploadResultsProgressText">' + textScreens['loader'][language]['start']  + '</h3>' +
          '<progress id="uploadResultsProgressBar" value="0" max="100" style="width:70%; height: 0.3rem;"></progress>' +
        '</div>';

      var xhrBuilderWithProgress =  null;

      xhrBuilderWithProgress = function(){
          var xhr = $.ajaxSettings.xhr();
          //Set a progress event handler
          xhr.upload.onprogress = function(data){
              var percentage = Math.round((data.loaded / data.total) * 100);
              var roundedPercentage = Math.round(percentage).toString();
              console.log('data upload status: ' + percentage + '%');
              $("#uploadResultsProgressBar").attr("value", roundedPercentage);
              $("#uploadResultsProgressText").text(roundedPercentage + textScreens['loader'][language]['uploading']);
          }
          return xhr;
      }
      
      Bugsnag && Bugsnag.leaveBreadcrumb('[download][saveRemote] Created xhrBuilderWithProgress. Send data.');

      $('#content').append(progressHTML);
      $.ajax({
      type: "POST",
      url: "serverSave2.php" + window.location.search, //relative to current route user_id/project_id/
      data: dataString,
      success: function(response, textStatus) {
        Bugsnag && Bugsnag.leaveBreadcrumb('[download][saveRemote] Sent and received', {response: response, textStatus: textStatus});
        if (response.error != undefined && response.error != '') {
          $('#title').html(response.error);
          $('#content').html('');
        } else {
          $('#hiddenForm').html("<div id='message'></div>");
          clearStoredData();
          $("#uploadResultsProgressText").text(textScreens['loader'][language]['success']);
          $("#uploadResultsProgressBar").hide();
          if (response) {
            participationPoolHandleResultSaveResponse(response);
          }
        }
      },
      error: function (jqXHR, textStatus, errorThrown ) {
        Bugsnag && Bugsnag.leaveBreadcrumb('[download][saveRemote] Sent and error', {statusCode: jqXHR.status, statusText: jqXHR.statusText, errorThrown: errorThrown, textStatus: textStatus, fileName: dataString.fileNameSubmit});
        Bugsnag && Bugsnag.notify(new Error('[download][saveRemote] Failed to send data to server.'));
        $('#uploadResultsProgressText').text(textScreens['loader'][language]['failure']);
        // var debriefContent = $('#content').html();
        // $('#content').html(debriefContent + '<br><br>' + textScreens['loader'][language]['failure']);
        var content = $('#content').html();
        var recoverUrl = window.location.href.replace('start', 'recover');
        var reuploadContent = textScreens['uploadError'][language]['retryNow'] + '<br><button id="retryUpload" onclick="reupload()">'+textScreens['uploadError'][language]['retryButton']+'</button><br> ' + textScreens['uploadError'][language]['retryLater'] + '<br><a href="' + recoverUrl + '">' + recoverUrl + '</a>';
        $('#content').html(content + reuploadContent);
        $("#uploadResultsProgressBar").hide();
      },
      xhr: xhrBuilderWithProgress
      });
  }

  function saveLocally() {
    var encodedUriLocal = encodeURI(csvContentLocal);
    var link = document.createElement("a");
    document.body.appendChild(link);// needed for Firefox; does it work in IE too?
    link.setAttribute("type", "hidden"); // make it hidden if needed
    link.setAttribute("id", "downloadlink"); // make it hidden if needed
    if(isIE){
    	encodedUriLocal = window.location.href.replace('start', 'results/'+fileNameLocal);
    }
    link.setAttribute("href", encodedUriLocal);
    link.setAttribute("download", fileNameLocal);

    // link.click(); // This will download the data file named "results.csv"; needs to be commented out if not wanted
    if (save_on_computer == "on"){
        link.click();
    }

    if (save_on_computer == "on" && save_on_server != "on" ) {
      //only local save
      $.post('localSave');
    }

    clearStoredData();
  }
}
